// GzEdN — Zwielicht/Flugblatt mode toggle. Persists to localStorage,
// respects prefers-color-scheme when the visitor has not chosen.
(function () {
    var KEY = 'gzedn-mode';
    var root = document.documentElement;

    function resolve() {
        var saved = null;
        try { saved = localStorage.getItem(KEY); } catch (e) {}
        if (saved === 'zwielicht' || saved === 'flugblatt') return saved;
        return matchMedia('(prefers-color-scheme: light)').matches ? 'flugblatt' : 'zwielicht';
    }
    function apply(mode) { root.setAttribute('data-theme', mode); }
    apply(resolve());

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mode-toggle]');
        if (!btn) return;
        var next = root.getAttribute('data-theme') === 'flugblatt' ? 'zwielicht' : 'flugblatt';
        apply(next);
        try { localStorage.setItem(KEY, next); } catch (e2) {}
    });

    // mobile-nav toggle — keeps aria-expanded on the burger in sync
    function setNav(open) {
        var nav = document.getElementById('site-nav');
        var btn = document.querySelector('[data-nav-toggle]');
        if (!nav) return;
        if (open === undefined) open = !nav.hasAttribute('data-open');
        nav.toggleAttribute('data-open', open);
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-nav-toggle]')) { setNav(); return; }
        // close when a nav link is followed
        if (e.target.closest('#site-nav a')) setNav(false);
    });

    // close the open panel on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setNav(false);
    });
})();
